import React from "react";
import { Link } from "react-router-dom";
import { usePartner } from "../context/PartnerContext";

const PublicFooter = () => {
  const { appName } = usePartner();
  return (
    <footer style={{ borderTop: "1px solid var(--border-subtle)" }}>
      {/* Risk Warning Bar */}
      <div style={{ background: "rgba(251,191,36,0.06)", borderBottom: "1px solid rgba(251,191,36,0.15)",
        padding: "10px 24px", textAlign: "center" }}>
        <p style={{ fontSize: 11, color: "var(--text-muted)", margin: 0, lineHeight: 1.6, maxWidth: 900, marginInline: "auto" }}>
          <span style={{ color: "var(--warning)", fontWeight: 700 }}>   Risk Warning: </span>
          Trading forex, commodities, and other financial instruments involves substantial risk of loss and is not suitable for all investors.
          Past performance is not indicative of future results. Copy trading does not guarantee profit.
          You should carefully consider your investment objectives, level of experience, and risk appetite before investing.
          {appName} is a non-custodial technology platform — your funds remain at your broker at all times.
          Please read our full <Link to="/legal/risk" style={{ color: "var(--warning)" }}>Risk Disclosure</Link> before using this platform.
        </p>
      </div>
      {/* Footer Bottom */}
      <div className="public-footer" style={{ borderTop: "none" }}>
        <div className="public-footer-left">
          <span className="public-footer-brand">© {new Date().getFullYear()} {appName}</span>
          <span className="public-footer-dot">•</span>
          <span className="public-footer-text">Non-custodial copy trading platform.</span>
        </div>
        <div className="public-footer-links">
          <Link to="/legal/terms">Terms</Link>
          <Link to="/legal/privacy">Privacy</Link>
          <Link to="/legal/risk">Risk Disclosure</Link>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
